import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

// 菜单路由
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '控制台', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/commission',
    component: Layout,
    redirect: '/commission/index',
    children: [
      {
        path: 'index',
        name: 'Commission',
        component: () => import('@/views/commission/Index'),
        meta: { title: '委托管理', icon: 'el-icon-s-order' }
      }
    ]
  },
  {
    path: '/samples',
    component: Layout,
    redirect: '/samples/index',
    children: [
      {
        path: 'index',
        name: 'Samples',
        component: () => import('@/views/samples/index'),
        meta: { title: '样品接收', icon: 'el-icon-s-management' }
      }
    ]
  },
  {
    path: '/reports',
    component: Layout,
    redirect: '/reports/index',
    children: [
      {
        path: 'index',
        name: 'Reports',
        component: () => import('@/views/reports/index'),
        meta: { title: '检测报告', icon: 'el-icon-document' }
      }
    ]
  },
  {
    path: '/users',
    component: Layout,
    redirect: '/users/index',
    children: [
      {
        path: 'index',
        name: 'Users',
        component: () => import('@/views/users/index'),
        meta: { title: '人员管理', icon: 'el-icon-user' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/log',
    name: 'System',
    meta: { title: '系统管理', icon: 'el-icon-setting', isMenu: true },
    children: [
      {
        path: 'log',
        name: 'Log',
        component: () => import('@/views/system/log'),
        meta: { title: '日志管理' }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/logs',
    component: Layout,
    redirect: '/logs/index',
    children: [
      {
        path: 'index',
        name: 'Logs',
        component: () => import('@/views/logs/index'),
        meta: { title: '日志管理' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/',
    hidden: true
  }
]

export default new Router({
  routes: constantRoutes
}) 